import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { CondicionesPagoConstant, TiposTablaComunConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const CondicionDePagoFormGroup = ({ iValue, iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [condicionesDePago, setCondiciones] = React.useState([])

  const selectRef = React.useRef()

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.CONDICIONESDEPAGO)
      .then(({ data }) => setCondiciones(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  React.useEffect(() => {
    setTimeout(() => {
      selectRef.current.focus()
    }, 250)
  }, [])

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(
        iValue === CondicionesPagoConstant.CREDITO
          ? 'button-formulariopagos-procesar'
          : 'date-fechaPago',
        e
      )
    },
    [iValue]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='condicionPago'>
          {({ field }) => (
            <Form.Select
              {...field}
              ref={selectRef}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-CondicionDePago'
              onKeyDown={onKeyDown}
            >
              {condicionesDePago.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionDePagoFormGroup)
